// Polyfills
import 'core-js/es6/promise';
import 'classlist.js';
import 'whatwg-fetch';
// import 'element-closest';
// import 'nodelist-foreach-polyfill';
import 'svgxuse';
// import { polyfill as smoothscrollPolyfill } from 'smoothscroll-polyfill';

//smoothscrollPolyfill();



// WEBPACK FOOTER //
// ./src/layouts/general/polyfills.js